import React, { useEffect, useState } from 'react';
import { Box, Fade, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddNewItem from '../ItemPage/AddNewItem';
import { useDispatch, useSelector } from 'react-redux';
import { settingsClose } from '../../../redux/reducers/companySkipSave';
import { useNavigate } from 'react-router-dom';
import { setCustomModalAction } from '../../../redux/reducers/controllNavigation';

const style = {
  position: 'absolute',
  right: '10%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  padding: '0px',
  overflow: 'hidden',
  height: '85%',
  '@media (min-width:600px)': {
    width: '80%',
  },
  width: '90%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50% )',
};
function AddNewItemModal({
  open,
  setOpen,
  modalEvent,
  setItemID,
  itemID,
  categoryId,
  itemType,
  page,
  itemName,
  getItems,
  invDate,
  setAccNames,
  view,
  rowIndex,
  listItems,
  initialBarcode = '',
}) {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (controllModal.isCheckModalBlocked && reason !== 'force') {
      dispatch(setCustomModalAction({ key: 'modalName', value: 'itemModal' }));
      dispatch(setCustomModalAction({ key: 'isModalOpen', value: true }));
      dispatch(
        setCustomModalAction({
          key: 'onLeaveFunction',
          value: () => setOpen(false),
        })
      );
      return;
    }
    if (modalEvent) {
      setOpen(false);
    } else {
      navigate('/newItemList');
    }
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  const controllModal = useSelector((state) => state.controllNavigationSlice);
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  return (
    <Modal
      id={open ? 'addItemModal' : ''}
      sx={{ width: '200px 200px'}}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {!itemID ? (
                    'Add Item'
                  ) : (
                    <span>
                      {itemName} ({itemType})
                    </span>
                  )}

                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box className={'custom-scrollbar'} sx={{ overflowY: 'scroll', flex: 1, p: '8px' }}>
              <Box>
                <AddNewItem
                  CategoryID={categoryId}
                  closeModal={handleClose}
                  modalEvent={modalEvent}
                  setItemID={setItemID}
                  itemType={itemType}
                  itemID={itemID}
                  getItems={getItems}
                  page={page}
                  invDate={invDate}
                  setAccNames={setAccNames}
                  view={view}
                  rowIndex={rowIndex}
                  listItems={listItems}
                  initialBarcode={initialBarcode}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddNewItemModal;
